
export const init = ({ additionalMtns, combinedIssueSelector, configData }) => {
    window.changeDeviceFlow = false;
    window.route1MtnId = ""
    console.log("additionalMtns", additionalMtns, combinedIssueSelector);
    const hashParts = window.location.hash.split("/");
    // routing1 changes
    // const URL = 'https://vzwqa2.verizonwireless.com/digital/nsa/secure/ui/troubleshooting/verizon-internet-gateway-ask-ncq1338#';
    if (combinedIssueSelector && !hashParts.includes("eotsecure") && !hashParts.includes("midflowsecure")) {
      try {
        if (window?.isLoggedOut == false || window?.isLoggedOut == null) {
          console.log("additionalMtns", additionalMtns);
          const URL = window.location.pathname;
          const seoUrl = URL.split("/").pop().replace("#", "");
          // const seoUrl = 'verizon-internet-gateway-ask-ncq1338';
  
          let foundMtn;
          if (Array.isArray(additionalMtns)) {
            foundMtn = additionalMtns.find((mtn) => mtn.seoUrl == seoUrl);
            window.route1MtnId = additionalMtns.indexOf(foundMtn);
          }
          console.log("additionalMtns route1MtnId", window.route1MtnId, foundMtn);
  
          if (window?.config?.caseDetails && foundMtn) {
            window.config.caseDetails.mtn = foundMtn?.mtn;
            window.config.caseDetails.mtnId = window.route1MtnId;
          }
          if (window?.config?.troubleShootingJson && foundMtn) {
            window.config.troubleShootingJson.ddata.device.deviceName =
              foundMtn?.deviceName;
            window.config.troubleShootingJson.ddata.device.deviceSku =
              foundMtn?.deviceSku;
            window.config.troubleShootingJson.ddata.device.equipmentId =
              foundMtn?.equipmentId;
          }
        }
      } catch (error) {
        console.error("routing error", error);
      }
    }
  
    try {
      const locationParts = window.location.hash.split("/");
      const isLvFlow = locationParts.includes("getcase");
      console.log(
        "routing2 index locationParts",
        locationParts,
        locationParts.length
      );

      console.log("page reload for 5G device")
      const troubleshootingDeviceJSON = JSON.parse(sessionStorage.getItem("troubleshootingDevice")) 
      const isURLReload = sessionStorage.getItem('currentPageUrl') && sessionStorage.getItem('currentPageUrl') === window.location.href ? true : false;
      if(troubleshootingDeviceJSON && isURLReload && window.config?.troubleShootingJson?.ddata?.device?.is5GDevice && !troubleshootingDeviceJSON?.is5GDevice) {
         console.log("Reset 5Gdevice value as before page load") 
         window.config.troubleShootingJson.ddata.device.is5GDevice = troubleshootingDeviceJSON.is5GDevice
      }
      
      if (locationParts.length > 3 && !locationParts.includes("eotsecure") && !locationParts.includes("midflowsecure")) {
        let intent = "";
        let intentId = "";
        const troubleshootingDetails = { ...window?.config?.caseDetails };
        if (!isLvFlow) {
          intent = decodeURIComponent(decodeURIComponent(locationParts[4]))
            .replace(/\+/g, " ")
            .replace(/%2C/g, ",");
          intentId = locationParts[2];
          troubleshootingDetails.intent = intent;
          troubleshootingDetails.intentId = intentId;
        }
  
        let foundMtn;
        let routeMtnId;
        const matchingItem = isLvFlow ? locationParts[2] : locationParts[3];
        if (Array.isArray(additionalMtns)) {
          foundMtn = additionalMtns.find((mtn) => mtn.mtnHash == matchingItem);
          routeMtnId = additionalMtns.indexOf(foundMtn);
        }
  
        if (foundMtn) {
          troubleshootingDetails.mtn = foundMtn.mtn;
          troubleshootingDetails.mtnId = routeMtnId;
          if (window?.config?.caseDetails) {
            window.config.caseDetails.mtnId = routeMtnId;
            window.config.caseDetails.mtn = foundMtn?.mtn;
            window.config.caseDetails.intent = intent;
            window.config.caseDetails.intentId = intentId;
          }
          if (window?.caseDetails) {
            window.caseDetails.mtnId = routeMtnId;
            window.caseDetails.mtn = foundMtn?.mtn;
            window.caseDetails.intent = intent;
            window.caseDetails.intentId = intentId;
          }
          if (window?.config?.troubleShootingJson) {
            window.config.troubleShootingJson.ddata.device.deviceName =
              foundMtn?.deviceName;
            window.config.troubleShootingJson.ddata.device.deviceSku =
              foundMtn?.deviceSku;
            window.config.troubleShootingJson.ddata.device.equipmentId =
              foundMtn?.equipmentId;
            window.config.troubleShootingJson.ddata.device.soeUrl =
              foundMtn?.seoUrl;
          }
          if (window?.troubleShootingJson) {
            window.troubleShootingJson.ddata.device.deviceName =
              foundMtn?.deviceName;
            window.troubleShootingJson.ddata.device.deviceSku =
              foundMtn?.deviceSku;
            window.troubleShootingJson.ddata.device.equipmentId =
              foundMtn?.equipmentId;
            window.troubleShootingJson.ddata.device.soeUrl = foundMtn?.seoUrl;
          }
        }
        if (window?.config?.caseDetails) {
          window.config.caseDetails.intent = intent;
          window.config.caseDetails.intentId = intentId;
        }
        console.log(
          "routing2 troubleshootingDetails",
          troubleshootingDetails,
          foundMtn?.mtn,
          routeMtnId,
          intent,
          intentId
        );
        sessionStorage.setItem(
          "troubleshootingDetails",
          JSON.stringify(troubleshootingDetails)
        );
        sessionStorage.setItem(
          "troubleshootingDevice",
          JSON.stringify(window?.config?.troubleShootingJson?.ddata?.device)
        );
      }
    } catch (error) {
      console.error("index location error", error);
    }
  
    try {
      if (hashParts.includes("eotsecure") || hashParts.includes("midflowsecure")) {
        console.log("-----inside EOTSECURE------>");
        const seoUrl = window.location.pathname
          .split("troubleshooting")[1]
          .split("/")[1];
        console.log("----- EOTSECURE Seo Url------>", seoUrl);
        // const seoUrl = "apple-iphone-413-pro-max";
  
        const filteredDevices = additionalMtns.filter(
          (device) => device.seoUrl === seoUrl
        );
        const size = filteredDevices.length;
  
        const intent = decodeURIComponent(
          decodeURIComponent(hashParts[3])
        ).replace(/\+/g, " ");
        const intentId = hashParts[2];
        console.log("intent intentID from url", intent, intentId);
        if (window.caseDetails) {
          window.caseDetails = { ...window.caseDetails, intent, intentId }; // update intent, intenitid, in caseDetails
          console.log("----- EOTSECURE window.caseDeatils update------>");
        }
        if (window.config?.caseDetails) {
          window.config.caseDetails = {
            ...window.config.caseDetails,
            intent,
            intentId,
          }; // update intent, intenitid, in caseDetails
          console.log("----- EOTSECURE window.config.caseDeatils update------>");
        }
        if (size === 0) {
          window.changeDeviceFlow = true;
          console.log("----- EOTSECURE size=0 changeDeviceflow=true------>");
        } else if (size === 1) {
          // update caseDeatils
          // intent
          // intentId
          // mtn
          // deviceSku
          // equipmentId
          // caseId
          console.log("----- EOTSECURE size=1 ------>");
          const {
            deviceName = "",
            deviceSku = "",
            mtn = "",
            equipmentId = "",
          } = filteredDevices[0];
          if (window.caseDetails) {
            window.caseDetails.mtn = mtn; // mtn in caseDetails
          }
          if (window.config?.caseDetails) {
            window.config.caseDetails.mtn = mtn; // mtn in caseDetails
          }
          if (window?.troubleShootingJson?.ddata?.device) {
            window.troubleShootingJson.ddata.device = {
              ...window?.troubleShootingJson?.ddata?.device,
              deviceName,
              deviceSku,
              equipmentId,
            };
          }
          if (window?.config?.troubleShootingJson?.ddata?.device) {
            window.config.troubleShootingJson.ddata.device = {
              ...window?.troubleShootingJson?.ddata?.device,
              deviceName,
              deviceSku,
              equipmentId,
            };
          }
        } else if (size > 1) {
          // redirect to device selector page
          console.log("----- EOTSECURE size>1 ------>");
          window.location.href = "/support/devices?banner=more-than-one-device";
        }
      }
    } catch (err) {
      console.log("Error in EOT SEcure");
    }
  
    try {
      const locationArr = window.location.href.split("/");
      console.log("route location", locationArr, window.location);
      if (
        locationArr.includes("chatbot") ||
        process.env.NODE_ENV == "development"
      ) {
        window.troubleShootingJson.ddata.device.is5GDevice = false;
        window.troubleShootingJson.ddata.device.isFwa = false;
        window.config.troubleShootingJson.ddata.device.is5GDevice = false;
        window.config.troubleShootingJson.ddata.device.isFwa = false;
      }
    } catch (error) {
      console.error(error);
    }
  
    if (window?.config) {
      window.config.isNewTemplate = configData?.isNewTemplate ?? false;
      window.config.pollDelay = configData?.pollDelay || 0;
      window.config.enableUILogging = configData?.enableUILogging || false;
      window.config.enableTechCoachinCIS =
        configData?.enableTechCoachinCIS || false;
      window.config.topIntents = configData?.topIntents ?? true;
      window.config.loggedOutCombinedIssueSelectorUrl =
        configData?.loggedOutCombinedIssueSelectorUrl || "";
      window.config.isTechCoachEligible =
        configData?.isTechCoachEligible || false;
       window.config.tangleWoodFlag = configData?.tangleWoodFlag || false;
    }
  };